const icons = {
    "fas fa-file-alt": ["txt"],
    "fas fa-file-image": ['jpg', 'jpeg', 'png', 'gif', 'tiff', 'psd', 'svg', 'webp'],
    "fas fa-file-video": ['webm', 'mpg', 'ogg', 'mp4', 'avi', 'mov'],
    "fas fa-file-pdf": ["pdf"],
    "fas fa-file-word": ['docx', 'docm', 'dot', 'dotx'],
    "fas fa-file-audio": ['mp3', 'aac', 'ogg']
}
const categories = {
    images: icons["fas fa-file-image"],
    videos: icons["fas fa-file-video"],
    documents: ([] as string[]).concat(icons["fas fa-file-word"], icons["fas fa-file-alt"], icons["fas fa-file-pdf"])
}

function getIcon(extension: string){
    const properties = Object.keys(icons);
    const values = Object.values(icons);

    let icon = undefined;
    for (let i=0; i<properties.length; i++) {
        if(values[i].includes(extension)) {
            icon = properties[i];
        }
    }
    return icon === undefined ? 'fas fa-file' : icon;
}

export default getIcon;
export { categories, icons };